import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// MUI Components
import MuiPagination from "@mui/lab/Pagination";
import PaginationItem from "@mui/lab/PaginationItem";

// Assets
import {black500, blueColor, grey200, grey300, grey400, greyishBlue100, greyishBlue400, greyishBlue500} from "assets/jss/main";
import {ReactComponent as ArrowRight} from "assets/img/wms/arrow-right-pagination.svg";
import {ReactComponent as ArrowLeft} from "assets/img/wms/arrow-left-pagination.svg";

Pagination.propTypes = {
    pageCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number,
    handlePageChange: PropTypes.func.isRequired,
    onClickPrevious: PropTypes.func,
    onClickNext: PropTypes.func,
    showPageCount: PropTypes.bool
};

function Pagination({pageCount, currentPage: initialCurrentPage = 1, onClickPrevious = () => {}, onClickNext = () => {}, handlePageChange = (page) => {}, showPageCount = true, props}) {
    const [currentPage, setCurrentPage] = React.useState(initialCurrentPage);

    const ArrowBackIcon = () => (
        <ArrowLeft
            onClick={onClickPrevious}
            width={'16px'}
            height={'16px'}
        />
    )

    const ArrowNextIcon = () => (
        <ArrowRight
            onClick={onClickNext}
            width={'16px'}
            height={'16px'}
        />
    )

    return (
        <div style={{
            paddingBottom: '16px',
            background: '#FFF',
            paddingTop: '32px',
        }}>
            <MuiPagination
                count={pageCount}
                page={currentPage}
                color="primary"
                shape="rounded"
                onChange={ (event, page) => {
                    setCurrentPage(page);
                    handlePageChange(page)
                }}
                sx={{
                    margin: 'auto',
                    textAlign: 'center',
                    'ul': {
                        display: 'flex',
                        justifyContent: 'center'
                    }
                }}
                renderItem={(item) => (
                    <PaginationItem
                        sx={{
                            minWidth: '40px',
                            height: '40px',
                            margin: '0 2px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            color: greyishBlue400,
                            '&:hover': {
                                backgroundColor: grey200
                            },
                            '&.MuiPaginationItem-ellipsis': {
                                fontWeight: 600,
                                color: greyishBlue400,
                            },
                            '&.MuiPaginationItem-previousNext' : {
                                opacity: 1,
                                margin: '0 22px',
                                background: item.type === 'previous' ? grey200 : grey300,
                                '&:hover': {
                                    backgroundColor: item.type === 'previous' ? grey300 : grey400
                                },
                                '&.Mui-disabled' : {
                                    'svg path': {
                                        stroke: greyishBlue100
                                    }
                                },
                                'svg path': {
                                    stroke: black500
                                }
                            },
                            '&.Mui-selected': {
                                background: blueColor,
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: blueColor
                                }
                            }
                        }}
                        slots={{ previous: ArrowBackIcon,next: ArrowNextIcon}}
                        {...item}
                    />
                )}
                {...props}
            />
            {showPageCount && (
                <div style={{
                    textAlign: 'center',
                    color: greyishBlue500,
                    fontSize: '12px',
                    marginTop: '16px'
                }}>
                    <FormattedMessage
                        id='wms.component.pagination.page'
                        values={{
                            page: currentPage,
                            totalPages: pageCount
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default Pagination;
